import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem;
  padding-bottom: 8rem;
  min-height: calc(100vh - 200px);
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
  font-family: 'Cormorant Garamond', serif;
  font-size: 2.5rem;
  font-weight: 400;
`;

const IntroText = styled.p`
  text-align: center;
  color: #666;
  font-family: 'EB Garamond', serif;
  font-size: 1.3rem;
  line-height: 1.8;
  margin-bottom: 4rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const HotelCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 3rem 2rem;
  margin: 2rem 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-2px);
  }
`;

const HotelName = styled.h2`
  color: #333;
  font-family: 'Cormorant Garamond', serif;
  font-size: 2.2rem;
  margin-bottom: 1rem;
  font-weight: 500;
`;

const HotelAddress = styled.p`
  color: #666;
  font-family: 'EB Garamond', serif;
  font-size: 1.2rem;
  font-style: italic;
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const HotelDescription = styled.p`
  color: #666;
  font-family: 'EB Garamond', serif;
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const ViewButton = styled.button`
  background: #333;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-family: 'EB Garamond', serif;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 1rem;

  &:hover {
    background: #444;
    transform: translateY(-2px);
  }
`;

const Travel = () => {
  const handleViewMarriott = () => {
    window.open('https://app.marriott.com/reslink?id=1763566425096&key=GRP&app=resvlink', '_blank');
  };

  const handleViewNoma = () => {
    window.open('https://www.wyndhamhotels.com/trademark/new-rochelle-new-york/hotel-noma-trademark-collection/overview', '_blank');
  };

  return (
    <PageContainer>
      <Title>Travel & Accommodations</Title>

      <IntroText>
        We're so grateful that you're making the trip to celebrate with us! Please see our hotel
        options below.
      </IntroText>

      <HotelCard>
        <HotelName>Courtyard by Marriott New York Manhattan/Midtown East</HotelName>
        <HotelAddress>866 Third Avenue New York, New York, USA, 10022</HotelAddress>

        <HotelDescription>
          We've secured a room block at The Courtyard by Marriott in Manhattan for your convenience.
          Please book using the link below to access our group rate.
        </HotelDescription>

        <ViewButton onClick={handleViewMarriott}>
          Book Your Room
        </ViewButton>
      </HotelCard>

      <HotelCard>
        <HotelName>Hotel NOMA</HotelName>
        <HotelAddress>1 Radisson Plaza, New Rochelle, New York, USA, 10801</HotelAddress>

        <HotelDescription>
          For guests who prefer to stay outside of Manhattan, the Hotel NOMA in New Rochelle is a
          great alternative. There is no room block at this hotel.
        </HotelDescription>

        <ViewButton onClick={handleViewNoma}>
          Book Your Room
        </ViewButton>
      </HotelCard>
    </PageContainer>
  );
};

export default Travel; 